export default async (ctx, inject) => {
  const options = {"el":{"icons":true,"email":"parts@paouris.gr","address":"50o χλμ. Ε.Ο. Αθηνών - Λαμίας, Aυλώνας Αττικής","geoAddress":"Paouris Parts Ανταλλακτικά Αυλώνας","phone":["+30 22950 42258"],"viber":"+30 6980 874 497","whatsapp":"+30 6980 874 497","businessHours":[{"days":"Δευτέρα - Παρασκευή","hours":"09:00 - 17:00"},{"days":"Σάββατο","hours":"09:00 - 15:00"},{"days":"Κυριακή","notes":"(κατόπιν ραντεβού)","hours":"10:00 - 14:00"}]},"en":{"icons":true,"email":"parts@paouris.gr","address":"50th km National Road Athens - Lamia Avlon, Attica 19011","geoAddress":"Paouris Parts Ανταλλακτικά Αυλώνας","phone":["+30 22950 42258"],"viber":"+30 6980 874 497","whatsapp":"+30 6980 874 497","businessHours":[{"days":"Monday - Friday","hours":"09:00 - 17:00"},{"days":"Saturday","hours":"09:00 - 15:00"},{"days":"Sunday","notes":"(by appointment)","hours":"10:00 - 14:00"}]}}
  const attrs = Object.values(options)[0]

  const contact = {
    ...options,
    get details() {
      return this[ctx.app.i18n.vm.locale] || {}
    }
  }

  Object.keys(attrs).forEach(key => {
    Object.defineProperty(contact, key, {
      get() {
        return this.details[key]
      }
    })
  })

  inject('contact', contact)
}
